import DropdownToggle from '../../../DropdownToggle/index';

import styles from './FooterNavGroupTitle.module.css';

type FooterNavGroupTitleProps = {
  isOpen: boolean;
  isUkFooterStyle?: boolean;
  subLinksId?: string;
  title: string;
  toggle(): void;
};

export const FooterNavGroupTitle = ({
  isOpen,
  isUkFooterStyle,
  subLinksId,
  title,
  toggle,
}: FooterNavGroupTitleProps) => {
  if (isUkFooterStyle) {
    return (
      <>
        <button
          aria-controls={subLinksId}
          aria-expanded={isOpen}
          className={styles.footerNavGroupTitleButtonUk}
          onClick={toggle}
          type="button"
        >
          <span className={styles.footerNavGroupTitleTextUk}>{title}</span>
          <DropdownToggle isOpen={isOpen} isUkFooterStyle />
        </button>
        <p className={styles.footerNavGroupTitleDesktopUk}>{title}</p>
      </>
    );
  }

  return (
    <div
      className={`${styles.footerNavGroupTitleWrapper} ${isOpen ? styles.footerNavGroupTitleWrapperOpen : ''}`}
      onClick={toggle}
    >
      <p className={styles.footerNavGroupTitleText}>{title}</p>
      <DropdownToggle isOpen={isOpen} />
    </div>
  );
};
